(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wl-consultation-booking"] && !Shopify.designMode) return;
  try {
    
class WlConsultationBooking extends HTMLElement {
  connectedCallback() {
    this.storageKey = this.dataset.storageKey || 'wl-consultation-booking';
    this.hasAvailabilityOption = this.dataset.hasAvailabilityOption === 'true';
    this.variants = this._readJson('[data-wl-cb-variants]');
    this.priorityVariants = this._readJson('[data-wl-cb-priority-variants]') || [];
    this.state = this._restoreState();

    this.querySelectorAll('[data-wl-cb-option1], [data-wl-cb-option2], [data-wl-cb-option3], [data-wl-cb-priority]').forEach((el) => {
      el.addEventListener('change', () => this._onFieldChange());
    });
    this.querySelectorAll('[data-wl-cb-next]').forEach((btn) => {
      btn.addEventListener('click', () => this._goTo(btn.dataset.wlCbNext, btn.hasAttribute('data-wl-cb-validate-step')));
    });
    this.querySelectorAll('[data-wl-cb-prev]').forEach((btn) => {
      btn.addEventListener('click', () => this._goTo(btn.dataset.wlCbPrev, false));
    });
    const formatPanel = this.querySelector('[data-wl-cb-panel="choose-format"]');
    if (formatPanel) {
      formatPanel.querySelectorAll('[data-wl-cb-option1]').forEach((input) => {
        input.addEventListener('change', () => this._goTo('choose-duration', false));
      });
      formatPanel.querySelectorAll('.wl-cb__card').forEach((card) => {
        card.addEventListener('click', () => {
          setTimeout(() => this._goTo('choose-duration', false), 0);
        });
      });
    }
    const checkoutBtn = this.querySelector('[data-wl-cb-checkout]');
    if (checkoutBtn) {
      this._checkoutLabel = checkoutBtn.textContent;
      checkoutBtn.addEventListener('click', () => this._checkout());
    }
    const previewBtn = this.querySelector('[data-wl-cb-preview-confirm]');
    if (previewBtn) previewBtn.addEventListener('click', () => this._goTo('schedule', false));

    this._applyRestoredSelections();
    this._onFieldChange();

    const previewState = this.dataset.previewState;
    if (previewState === 'confirmation') {
      this._goTo('schedule', false);
    } else {
      const validSteps = ['choose-format', 'choose-duration', 'choose-availability', 'review', 'pay', 'schedule'];
      const initialStep = validSteps.indexOf(this.state.step) !== -1 ? this.state.step : 'choose-format';
      this._goTo(initialStep, false);
    }
  }

  _readJson(selector) {
    const el = this.querySelector(selector);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  _restoreState() {
    try {
      const raw = sessionStorage.getItem(this.storageKey);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  _persistState() {
    try {
      sessionStorage.setItem(this.storageKey, JSON.stringify(this.state));
    } catch (e) {
      /* sessionStorage unavailable — state simply doesn't persist across reloads */
    }
  }

  _applyRestoredSelections() {
    if (!this.state.format) return;
    const setChecked = (selector, value) => {
      const el = this.querySelector(`${selector}[value="${CSS.escape(value)}"]`);
      if (el) el.checked = true;
    };
    if (this.state.format) setChecked('[data-wl-cb-option1]', this.state.format);
    if (this.state.duration) setChecked('[data-wl-cb-option2]', this.state.duration);
    if (this.state.priority) {
      setChecked('[data-wl-cb-option3]', this.state.priority);
      setChecked('[data-wl-cb-priority]', this.state.priority);
    }
  }

  _onFieldChange() {
    const format = this.querySelector('[data-wl-cb-option1]:checked');
    const duration = this.querySelector('[data-wl-cb-option2]:checked');
    const availability = this.querySelector('[data-wl-cb-option3]:checked');
    const priority = availability || this.querySelector('[data-wl-cb-priority]:checked');

    const variant = this.variants && this.variants.find((v) => {
      const m1 = format ? v.option1 === format.value : true;
      const m2 = duration ? v.option2 === duration.value : true;
      const m3 = availability ? v.option3 === availability.value : true;
      return m1 && m2 && m3;
    });
    const priorityVariant = priority && this.priorityVariants.find((v) => v.tier === priority.value);

    this.state.format = format ? format.value : null;
    this.state.duration = duration ? duration.value : null;
    this.state.priority = priority ? priority.value : null;
    this.state.variantId = variant ? variant.id : null;
    this._persistState();

    const setText = (selector, text) => {
      this.querySelectorAll(selector).forEach((el) => {
        el.textContent = text || '—';
      });
    };
    setText('[data-wl-cb-summary-format]', this.state.format);
    setText('[data-wl-cb-summary-duration]', this.state.duration);
    setText('[data-wl-cb-summary-priority]', this.state.priority);
    setText('[data-wl-cb-summary-total]', variant ? variant.price : null);
  }

  _validateStep() {
    const activePanel = this.querySelector('[data-wl-cb-panel="review"]');
    if (!activePanel || activePanel.hidden) return true;
    const inputs = activePanel.querySelectorAll('[data-wl-cb-validate]');
    let valid = true;
    inputs.forEach((input) => {
      if (!input.checkValidity()) valid = false;
    });
    const errorEl = this.querySelector('[data-wl-cb-error]');
    if (errorEl) errorEl.hidden = valid;
    return valid;
  }

  _bookingProperties() {
    const get = (name) => {
      const el = this.querySelector('[name="' + name + '"]');
      return el ? el.value : '';
    };
    return {
      Format: this.state.format || '',
      Duration: this.state.duration || '',
      Availability: this.state.priority || '',
      Name: get('wl-cb-name'),
      Email: get('wl-cb-email'),
      Phone: get('wl-cb-phone'),
      Country: get('wl-cb-country')
    };
  }

  async _checkout() {
    const btn = this.querySelector('[data-wl-cb-checkout]');
    const errorEl = this.querySelector('[data-wl-cb-checkout-error]');
    if (errorEl) errorEl.hidden = true;

    if (!this.state.variantId) {
      if (errorEl) {
        errorEl.textContent = this.dataset.errorNoSelection || 'Please choose a format, duration and availability first.';
        errorEl.hidden = false;
      }
      return;
    }

    const items = [{ id: this.state.variantId, quantity: 1, properties: this._bookingProperties() }];
    if (!this.hasAvailabilityOption) {
      const priorityVariant = this.priorityVariants.find((v) => v.tier === this.state.priority);
      if (priorityVariant && priorityVariant.id !== this.state.variantId) {
        items.push({ id: priorityVariant.id, quantity: 1, properties: { 'Consultation availability tier': this.state.priority } });
      }
    }

    if (btn) {
      btn.disabled = true;
      btn.textContent = this.dataset.checkoutLoadingLabel || this._checkoutLabel;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!response.ok) throw new Error('cart_add_failed');
      window.location.href = '/checkout';
    } catch (e) {
      if (errorEl) {
        errorEl.textContent = this.dataset.checkoutError || 'We could not secure your reservation. Please try again.';
        errorEl.hidden = false;
      }
      if (btn) {
        btn.disabled = false;
        btn.textContent = this._checkoutLabel;
      }
    }
  }

  _progressStepFor(step) {
    if (step === 'choose-format' || step === 'choose-duration' || step === 'choose-availability') return 'choose';
    return step;
  }

  _goTo(step, requiresValidation) {
    if (requiresValidation && !this._validateStep()) return;
    this.querySelectorAll('[data-wl-cb-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.wlCbPanel !== step;
    });
    const progressStep = this._progressStepFor(step);
    this.querySelectorAll('[data-wl-cb-step-indicator]').forEach((li) => {
      if (li.dataset.wlCbStepIndicator === progressStep) {
        li.setAttribute('data-wl-cb-active', '');
        li.setAttribute('aria-current', 'step');
      } else {
        li.removeAttribute('data-wl-cb-active');
        li.removeAttribute('aria-current');
      }
    });
    const summaryEl = this.querySelector('[data-wl-cb-summary]');
    if (summaryEl) summaryEl.hidden = step === 'choose-format';
    this.state.step = step;
    this._persistState();
    this.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
if (!customElements.get('wl-consultation-booking')) {
  customElements.define('wl-consultation-booking', WlConsultationBooking);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-guided-intake"] && !Shopify.designMode) return;
  try {
    
class WlGuidedIntake extends HTMLElement {
  connectedCallback() {
    this.screens = Array.from(this.querySelectorAll('[data-wl-intake-screen]'));
    this.current = 1;
    this.backBtn = this.querySelector('[data-wl-intake-back]');
    this.nextBtn = this.querySelector('[data-wl-intake-next]');
    this.submitBtn = this.querySelector('[data-wl-intake-submit]');
    this.summaryEl = this.querySelector('[data-wl-intake-summary]');

    this.backBtn.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn.addEventListener('click', () => this.go(this.current + 1));

    this.render();
  }

  go(step) {
    const max = this.screens.length;
    if (step < 1 || step > max) return;
    this.current = step;
    if (step === max) this.buildSummary();
    this.render();
  }

  render() {
    this.screens.forEach((screen) => {
      screen.hidden = parseInt(screen.dataset.wlIntakeScreen, 10) !== this.current;
    });
    this.querySelectorAll('[data-wl-intake-indicator]').forEach((li) => {
      const isCurrent = parseInt(li.dataset.wlIntakeIndicator, 10) === this.current;
      if (isCurrent) li.setAttribute('aria-current', 'step');
      else li.removeAttribute('aria-current');
    });
    this.backBtn.hidden = this.current === 1;
    const isLast = this.current === this.screens.length;
    this.nextBtn.hidden = isLast;
    this.submitBtn.hidden = !isLast;
  }

  buildSummary() {
    if (!this.summaryEl) return;
    const fields = this.querySelectorAll('input[name^="properties"], textarea[name^="properties"], select[name^="properties"]');
    const lines = [];
    fields.forEach((field) => {
      const label = field.closest('.wl-form-field')?.querySelector('.wl-form-field__label')?.textContent?.trim();
      if (label && field.value) lines.push(label.replace('*', '').trim() + ': ' + field.value);
    });
    this.summaryEl.innerHTML = lines.map((l) => '<p>' + l.replace(/</g, '&lt;') + '</p>').join('');
  }
}
if (!customElements.get('wl-guided-intake')) {
  customElements.define('wl-guided-intake', WlGuidedIntake);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-healing-journey-selector"] && !Shopify.designMode) return;
  try {
    
class WlHealingSelector extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('[data-wl-healing-form]');
    const variantsEl = this.querySelector('[data-wl-variants]');
    if (!form || !variantsEl) return;
    let variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent);
    } catch (e) {
      return;
    }
    const idInput = form.querySelector('[data-wl-variant-input]');
    const priceEl = form.querySelector('[data-wl-price]');
    const submitBtn = form.querySelector('[data-wl-healing-submit]');

    const update = () => {
      const opt1 = form.querySelector('[data-wl-option1]:checked');
      const opt2 = form.querySelector('[data-wl-option2]:checked');
      const match = variants.find((v) => {
        const matches1 = opt1 ? v.option1 === opt1.value : true;
        const matches2 = opt2 ? v.option2 === opt2.value : true;
        return matches1 && matches2;
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (submitBtn) submitBtn.disabled = !match.available;
    };

    form.addEventListener('change', update);
    update();
  }
}
if (!customElements.get('wl-healing-selector')) {
  customElements.define('wl-healing-selector', WlHealingSelector);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-help-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  var input = document.querySelector('[data-wl-help-search-input]');
  if (!input) return;
  var emptyEl = document.querySelector('[data-wl-help-search-empty]');

  input.addEventListener('input', function () {
    var query = input.value.trim().toLowerCase();
    var items = document.querySelectorAll('.wl-faq__item');
    var visibleCount = 0;
    items.forEach(function (item) {
      var text = item.textContent.toLowerCase();
      var matches = query === '' || text.indexOf(query) !== -1;
      item.hidden = !matches;
      if (matches) visibleCount += 1;
    });
    if (emptyEl) emptyEl.hidden = query === '' || visibleCount > 0;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-main-product"] && !Shopify.designMode) return;
  try {
    
class WlProductForm extends HTMLElement {
  connectedCallback() {
    const form = this.querySelector('[data-wl-product-form]');
    if (!form) return;
    const variantsEl = this.querySelector('[data-wl-pdp-variants]');
    const idInput = form.querySelector('[data-wl-pdp-variant-input]');
    const submitBtn = form.querySelector('[data-wl-pdp-submit]');
    let variants = [];
    if (variantsEl) {
      try { variants = JSON.parse(variantsEl.textContent); } catch (e) { variants = []; }
    }
    if (variants.length) {
      const update = () => {
        const selected = [];
        form.querySelectorAll('[data-wl-pdp-option]:checked').forEach((el) => {
          selected[parseInt(el.dataset.wlPdpOption, 10)] = el.value;
        });
        const match = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        if (!match) return;
        idInput.value = match.id;
        if (submitBtn) submitBtn.disabled = !match.available;
      };
      form.addEventListener('change', update);
    }

    // Sticky mobile bar: mirror the main submit once the primary button scrolls out of view.
    const stickyBar = this.closest('.wl-pdp')?.querySelector('[data-wl-pdp-sticky]');
    const stickySubmit = stickyBar?.querySelector('[data-wl-pdp-sticky-submit]');
    if (stickySubmit) stickySubmit.addEventListener('click', () => form.requestSubmit());
    if (stickyBar && submitBtn && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      });
      observer.observe(submitBtn);
    }
  }
}
if (!customElements.get('wl-product-form')) {
  customElements.define('wl-product-form', WlProductForm);
}

// Related products (P06 §10) — fetch this section standalone via
// ?section_id=, matching Dawn's own recommendations pattern.
(function () {
  var containers = document.querySelectorAll('[data-wl-related-products]');
  containers.forEach(function (container) {
    var url = container.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var source = doc.getElementById(container.id);
        if (source && source.innerHTML.trim()) {
          container.innerHTML = source.innerHTML;
        }
      })
      .catch(function () {});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-policy-body"] && !Shopify.designMode) return;
  try {
    
(function () {
  var content = document.querySelector('[data-wl-policy-content]');
  var tocNav = document.querySelector('[data-wl-policy-toc]');
  var tocList = document.querySelector('[data-wl-policy-toc-list]');
  if (!content || !tocNav || !tocList) return;
  var headings = content.querySelectorAll('h2');
  if (!headings.length) return;
  headings.forEach(function (heading, index) {
    if (!heading.id) heading.id = 'wl-policy-section-' + index;
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + heading.id;
    a.textContent = heading.textContent;
    li.appendChild(a);
    tocList.appendChild(li);
  });
  tocNav.hidden = false;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-real-experiences"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.wl-testimonial__play');
  if (!trigger) return;
  var media = trigger.closest('.wl-testimonial__media');
  var video = media && media.querySelector('video');
  if (!video) return;
  media.classList.add('is-playing');
  video.muted = false;
  video.play();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-scroll-story"] && !Shopify.designMode) return;
  try {
    
class WlScrollStory extends HTMLElement {
  connectedCallback() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (reduceMotion || isMobile) return; // plain stacked fallback (CSS only)

    this.frames = Array.from(this.querySelectorAll('[data-wl-scroll-frame]'));
    this.copies = Array.from(this.querySelectorAll('[data-wl-scroll-copy]'));
    this.track = this.querySelector('.wl-scroll-story__track');
    if (!this.track || this.frames.length < 2) return;

    this.classList.add('is-upgraded');
    this.frames.forEach((f) => { f.hidden = false; });
    this.copies.forEach((c) => { c.hidden = false; });

    // Lazy-load each stage's static video source only once its frame
    // becomes the active (or next-up) stage — never fetch all 5 at once.
    this.videos = this.frames.map((f) => f.querySelector('[data-wl-scroll-video]'));

    const n = this.frames.length;
    // Even thresholds by default (Parallel Track 1D.2 §D starting
    // guidance): stage i owns [i/n, (i+1)/n) of total scroll progress.
    // A short overlap window on each boundary is where the crossfade
    // between neighbours actually happens, instead of a hard snap.
    const overlap = 0.08; // 8 percentage points either side of a boundary — image crossfade
    const textOverlap = 0.025; // text switches over a much shorter window than the image
    // (Parallel Track 1D.2 §9: text should "fade in, remain stable, fade
    // naturally" — never two headings visibly overlapping mid-thought).
    this.thresholds = Array.from({ length: n }, (_, i) => i / n);

    let ticking = false;
    const update = () => {
      ticking = false;
      const rect = this.track.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      const scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
      const progress = total > 0 ? scrolled / total : 0;

      this.frames.forEach((frame, i) => {
        const start = this.thresholds[i];
        const end = i + 1 < n ? this.thresholds[i + 1] : 1;
        let opacity = 0;
        if (progress >= start - overlap && progress <= end + overlap) {
          if (progress < start) opacity = 1 - (start - progress) / overlap;
          else if (progress > end) opacity = 1 - (progress - end) / overlap;
          else opacity = 1;
        }
        opacity = Math.min(Math.max(opacity, 0), 1);
        frame.classList.toggle('is-active', opacity > 0.02);
        frame.style.opacity = opacity;

        const copy = this.copies[i];
        if (copy) {
          let textOpacity = 0;
          if (progress >= start - textOverlap && progress <= end + textOverlap) {
            if (progress < start) textOpacity = 1 - (start - progress) / textOverlap;
            else if (progress > end) textOpacity = 1 - (progress - end) / textOverlap;
            else textOpacity = 1;
          }
          copy.style.opacity = Math.min(Math.max(textOpacity, 0), 1);
        }

        // Stage 01 (or any block flagged scale_drift): drive the slow
        // 100%->104% drift from this stage's own local progress only.
        if (frame.classList.contains('wl-scroll-story__frame--scale-drift')) {
          const local = Math.min(Math.max((progress - start) / (end - start || 1), 0), 1);
          frame.style.setProperty('--wl-scroll-drift-scale', (1 + local * 0.04).toFixed(4));
        }

        // Lazy-load + play/pause the static video for whichever stage is
        // active or immediately upcoming; pause and never autoplay the rest.
        const video = this.videos[i];
        if (video) {
          const nearby = opacity > 0.02 || i === Math.round(progress * (n - 1)) + 1;
          if (nearby && !video.src) {
            const source = video.querySelector('[data-wl-scroll-video-src]');
            if (source) video.src = source.getAttribute('data-wl-scroll-video-src');
            video.load();
          }
          if (opacity > 0.5) {
            if (video.paused) video.play().catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        }
      });
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });
    window.addEventListener('resize', () => requestAnimationFrame(update), { passive: true });

    update();
  }
}
if (!customElements.get('wl-scroll-story')) {
  customElements.define('wl-scroll-story', WlScrollStory);
}

  } catch(e) { console.error(e); }
})();
})();
